import * as React from 'react'
import { CastingStore } from '../../../services/stores/casting.store'
import { PrimaryButton } from './casting-styled.component'

type Props = Pick<React.ButtonHTMLAttributes<HTMLAnchorElement | HTMLButtonElement>, 'id' | 'onClick' | 'children' | 'disabled'> & Pick<CastingStore['data'], 'renderingMode'>

export default function CastingTooltipButtonComponent ({ renderingMode, disabled, ...otherProps }: Props) {
  if (renderingMode === 'widget') {
    return !disabled && <PrimaryButton style={{ display: 'block', marginTop: '1em' }} { ...otherProps } />
  }

  return <div className="buttonContainer--centered u-mts">
    <button
      className={ `${renderingMode === 'mobile' ? 'button u-mtm u-mbm' : 'buttonNeutral button--XS'} button--main is-pulse` }
      disabled={ disabled }
      { ...otherProps } />
  </div>
}